import { convertDateTime } from '~/utils/dateTime';
import { getGroupsNewLink } from '~/utils/getLinks';
import { useGroupList } from '../../hooks';
import { GroupRow } from '../../types';

type Args = { data: ReturnType<typeof useGroupList>['state'] };

type Result = {
  groups: GroupRow[];
  createLink: string;
};

type IConvertToPresentationProps = (args: Args) => Result;

export const convertToPresentationProps: IConvertToPresentationProps = ({ data }) => {
  const groups = data.groups.map(group => ({
    id: group.id,
    name: group.name,
    code: group.code,
    description: group.description,
    createdAt: convertDateTime(group.created_at),
    updatedAt: convertDateTime(group.updated_at),
  }));

  return { groups, createLink: getGroupsNewLink() };
};
